module.exports = __webpack_public_path__ + "img/conveyor-belt-empty.2eb48dac.svg";